module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/bass-guitars-ff83b264ca64d9180e5e6cff963d93eb.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/bass-guitars.png
// module id = 1Zyu
// module chunks = 12 16 18